export default () => {
    return (
        <div
            className="relative xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16"
            id="transformations"
        >
            <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                <div className="text-center">
                    <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                        <span className="text-we-are-yellow">We </span>
                        <span className="text-we-are-purple">Are</span>
                    </p>
                    <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                        Transformaties
                    </h2>
                    <p className="max-w-2xl mt-5 mx-auto text-xl text-gray-100">
                        Met meer dan 1000+ transformaties zijn we de
                        specialisten op het gebied van Personal Training. Ook
                        voor jou is dit allemaal mogelijk! We staan klaar om je
                        te ontvangen op onze locatie in Uden of Schijndel.
                    </p>
                </div>
            </div>

            <h2 id="gallery-heading" className="sr-only">
                Transformaties
            </h2>
            <ul
                role="list"
                className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8"
            >
                {[...Array(8)].map((x, i) => (
                    <li className="relative ml-0 p-2 lg:px-4" key={i}>
                        <div
                            className={
                                "group block w-full aspect-w-10 aspect-h-10 rounded-lg bg-black"
                            }
                        >
                            <picture>
                                <source
                                    srcSet={`/assets/home/webp/home-${
                                        1 + i
                                    }.webp`}
                                    width="960"
                                    height="960"
                                    type="image/webp"
                                    alt={"Transformatie " + (1 + i)}
                                    className="object-cover pointer-events-none"
                                />
                                <source
                                    srcSet={`/assets/home/home-${
                                        1 + i
                                    }.jpg`}
                                    width="960"
                                    height="960"
                                    type="image/jpeg"
                                    alt={"Transformatie " + (1 + i)}
                                    className="object-cover pointer-events-none"
                                />
                                <img
                                    src={`/assets/home/home-${
                                        1 + i
                                    }.jpg`}
                                    width="960"
                                    height="960"
                                    alt={"Transformatie " + (1 + i)}
                                    className="object-cover pointer-events-none"
                                />
                            </picture>
                        </div>
                    </li>
                ))}
            </ul>

            <div className="text-center">
                <a
                    href={route("twelve-week-program")}
                    className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    Meer informatie
                </a>
                {/* <a
                    href="/resultaten"
                    className="mt-12 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    Bekijk alle succesverhalen
                </a> */}
            </div>
        </div>
    );
};
